var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./consulta-alterar-revisao.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c84a9e20\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./consulta-alterar-revisao.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/apps/web/consulta-externa/_include/consulta-alterar-revisao.vue
// module id = 1311
// module chunks = 45